<template>
  <div class="main">
    <h1>Search Video</h1>
    <div class="container">
      <div class="row">
        <!-- Actual search box
          <div class="form-group has-search">
            <span class="fa fa-search form-control-feedback"></span>
            <input type="text" class="form-control" placeholder="Search" />
          </div> -->

        <!-- Another variation with a button -->
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Search"
            v-model="searchText"
            @keyup.enter="searchVideos"
          />
          <div class="input-group-append">
            <button
              class="btn btn-secondary"
              type="button"
              @click="searchVideos"
            >
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="input-group">
          <div class="form-check">
            <label class="form-check-label">
              <input
                type="radio"
                class="form-check-input"
                name="optradio"
                v-model="channelSelected"
                value="UCy5PF5D8UCeg27sWkZOjQ6A"
                checked="checked"
              />SteveNgaiCheeWeng Channel
            </label>
          </div>
          <div class="form-check">
            <label class="form-check-label">
              <input
                type="radio"
                class="form-check-input"
                value=""
                name="optradio"
                v-model="channelSelected"
              />Any Channel
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="main">
          <ol>
            <li
              class="searchResultList"
              v-bind:key="searchResult.id"
              v-for="searchResult in searchResults"
              @click="showModal(searchResult.id.videoId)"
            >
              {{ searchResult.snippet.title }}
            </li>
          </ol>
        </div>
        <div>
          <b-modal
            id="modal-1"
            title=""
            v-model="modalOpen"
            size="xl"
            :hide-footer="true"
          >
            <p class="my-4"><VideoIFrame :iframesrc="currentURL" /></p>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VideoIFrame from "@/components/VideoIFrame.vue";
import store from "@/components/store";

const key = "AIzaSyAUHqj8bukFN8gTxiRUtQB846ABSYDs7Zo";
const URL = "https://www.googleapis.com/youtube/v3/search";

export default {
  components: {
    VideoIFrame
  },
  data() {
    return {
      searchText: null,
      channelSelected: "UCy5PF5D8UCeg27sWkZOjQ6A",
      searchResults: [],
      modalOpen: false,
      currentURL: ""
    };
  },
  methods: {
    searchVideos() {
      debugger;
      const options = {
        params: {
          part: "snippet",
          channelId: this.channelSelected,
          type: "video",
          key: key,
          maxResults: 20,
          q: this.searchText
        }
      };
      axios
        .get(URL, options)
        .then(response => (this.searchResults = response.data.items))
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          debugger;
          console.log(this.searchResults);
        });
    },
    showModal(videoURI) {
      debugger;
      this.modalOpen = true;
      this.currentURL = videoURI;
      store.iframesrc = "https://www.youtube.com/embed/" + videoURI;
      //this.$bvModal.show("modal-1");
    }
  }
};
</script>

<style>
.form-check {
  margin-right: 100px;
}
.searchResultList {
  cursor: pointer;
  padding: 5px;
}

/* Bootstrap 4 text input with search icon */
.row {
  display: block;
}
.has-search .form-control {
  padding-left: 2.375rem;
}

.has-search .form-control-feedback {
  position: absolute;
  z-index: 2;
  display: block;
  width: 2.375rem;
  height: 2.375rem;
  line-height: 2.375rem;
  text-align: center;
  pointer-events: none;
  color: #aaa;
}
</style>
